import { useState } from "react";
import { ArrowUpDown, ChevronDown, MoreHorizontal } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  IconButton,
  Menu,
  MenuItem,
  Button,
  Typography,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const referrals = [
  {
    id: "REF-001",
    user: "John Smith",
    email: "john.smith@example.com",
    purchaseDate: "March 1, 2025",
    releaseDate: "April 1, 2025",
    trip: "Paris Getaway",
    amount: "$120.00",
    status: "pending",
  },
  {
    id: "REF-002",
    user: "Emily Johnson",
    email: "emily.j@example.com",
    purchaseDate: "February 25, 2025",
    releaseDate: "March 25, 2025",
    trip: "Tokyo Adventure",
    amount: "$210.50",
    status: "pending",
  },
  {
    id: "REF-003",
    user: "Michael Brown",
    email: "michael.b@example.com",
    purchaseDate: "February 20, 2025",
    releaseDate: "March 20, 2025",
    trip: "New York City Tour",
    amount: "$150.00",
    status: "pending",
  },
  {
    id: "REF-004",
    user: "Sarah Wilson",
    email: "sarah.w@example.com",
    purchaseDate: "February 15, 2025",
    releaseDate: "March 15, 2025",
    trip: "Rome Explorer",
    amount: "$180.25",
    status: "pending",
  },
  {
    id: "REF-005",
    user: "David Lee",
    email: "david.l@example.com",
    purchaseDate: "February 10, 2025",
    releaseDate: "March 10, 2025",
    trip: "Bali Retreat",
    amount: "$250.00",
    status: "pending",
  },
  {
    id: "REF-006",
    user: "Jessica Taylor",
    email: "jessica.t@example.com",
    purchaseDate: "January 28, 2025",
    releaseDate: "February 28, 2025",
    trip: "Barcelona Weekend",
    amount: "$95.75",
    status: "confirmed",
  },
  {
    id: "REF-007",
    user: "Robert Martinez",
    email: "robert.m@example.com",
    purchaseDate: "January 20, 2025",
    releaseDate: "February 20, 2025",
    trip: "London Explorer",
    amount: "$175.00",
    status: "cancelled",
  },
];

export function AffiliateTable() {
  const [sorting, setSorting] = useState("newest");
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <TableContainer component={Paper} className="tw-shadow-md">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Status</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Trip</TableCell>
            <TableCell>Purchase date</TableCell>
            <TableCell>Release date</TableCell>
            <TableCell>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {referrals.map((referral) => (
            <TableRow key={referral.id}>
              <TableCell>
                {referral.status === "pending" ? (
                  <span className="tw-text-orange-500 tw-font-medium">
                    Pending
                  </span>
                ) : referral.status === "cancelled" ? (
                  <span className="tw-text-red-500 tw-font-medium">
                    Cancelled
                  </span>
                ) : referral.status === "confirmed" ? (
                  <span className="tw-text-green-500 tw-font-medium">
                    Confirmed
                  </span>
                ) : (
                  ""
                )}
              </TableCell>
              <TableCell>{referral.user}</TableCell>
              <TableCell>{referral.trip}</TableCell>
              <TableCell>{referral.purchaseDate}</TableCell>
              <TableCell>{referral.releaseDate}</TableCell>
              <TableCell>{referral.amount}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
